module.exports = __webpack_public_path__ + "img/info-circle.c45550de.svg";